import { SvgScissors } from '@loomhq/lens';
import React from 'react';
import { connect } from 'react-redux';

import { ROLLOUT_WEAVE, VARIANT } from 'constants/featureFlag';
import { VIDEO_ENTER_TRIM_MODE } from 'constants/hotkeys';
import * as device from 'utilities/device';

import { useFeatureFlagValue } from 'hooks/featureFlag';

import CollapsibleSideButton from '../collapsible-side-button';

const TrimModeButton = ({
  onClick,
  enterTrimEnabled,
  isCollapsed,
  disabled,
  currentUserCanEdit,
  customLabel = '',
}) => {
  const weaveFlagValue = useFeatureFlagValue(ROLLOUT_WEAVE);
  const rolloutWeave = VARIANT.includes(weaveFlagValue);

  // NOTE(weave): temporarily enabling this if you are using Weave
  enterTrimEnabled = enterTrimEnabled || rolloutWeave;

  const userCanEdit = currentUserCanEdit;

  const trimButtonHotKey = `(${VIDEO_ENTER_TRIM_MODE[0]})`;
  let trimButtonLabel = `${trimButtonHotKey} Trim video`;

  if (customLabel) {
    trimButtonLabel = customLabel;
  } else if (rolloutWeave) {
    trimButtonLabel = `${trimButtonHotKey} Trim and add clips`;
  }

  return (
    !device.isMobile &&
    userCanEdit && (
      <CollapsibleSideButton
        id="trimAndAddClips"
        icon={<SvgScissors />}
        isCollapsed={isCollapsed}
        isDisabled={disabled || !enterTrimEnabled}
        onClick={enterTrimEnabled ? onClick : undefined}
      >
        {trimButtonLabel}
      </CollapsibleSideButton>
    )
  );
};

const mapStateToProps = state => {
  const { player_ready, video } = state.share_video;

  const { processing_information = {} } = video;
  const { trim_id, trim_progress } = processing_information;

  // the user should be able to enter trim mode if the player is ready or if
  // a trim job is progressing
  const enterTrimEnabled =
    player_ready || (trim_id != null && trim_progress !== 100);

  return {
    enterTrimEnabled,
    currentUserCanEdit: video.currentUserCanEdit,
  };
};

export default connect(mapStateToProps)(TrimModeButton);
